import * as React from 'react';
import classnames from 'classnames';

import { AppPicture } from '@src/services/app/components/AppPicture/AppPicture';

export interface PhilosophyProps {
  className?: string;
}

/**
 * @name Philosophy
 * @description Component rendering Haldi's sustainability philosophy.
 */
export const Philosophy = (props: PhilosophyProps) => {
  const { className } = props;

  return (
    <div
      className={classnames(
        'gap-6 bg-pine p-10 text-center text-white',
        className
      )}
    >
      <h2 className="font-bold">Our Philosophy:</h2>
      <h1>Use what you have, buy only what you need.</h1>
      <div className="hidden min-w-[675px] items-start justify-center md:mb-6 md:flex">
        <AppPicture png="/images/png/tape_left.png" />
        <h1 className="m-0 bg-[#267a65]">
          It's our unique take on sustainability
        </h1>
        <AppPicture png="/images/png/tape_right.png" />
      </div>
      <div className="flex flex-col md:hidden">
        <div className="flex min-w-[400px] items-start justify-center">
          <AppPicture png="/images/png/tape_left.png" />
          <h1 className="m-0 bg-[#267a65]">It's our unique take</h1>
          <AppPicture png="/images/png/tape_right.png" />
        </div>
        <div className="center flex min-w-[305px] items-start justify-center">
          <AppPicture png="/images/png/tape_left.png" />
          <h1 className="m-0 bg-[#267a65]">on sustainability</h1>
          <AppPicture png="/images/png/tape_right.png" />
        </div>
      </div>
    </div>
  );
};
